import * as React from 'react';

// PACKAGES
import { Link } from 'react-router-dom';

// ICONS
import { ReactComponent as ArrowDownIcon } from '../assets/svg/arrow-down-white.svg';

export interface AccordionTypes {
	heading?: string;
	content?: string;
	colorCode?: string;
	redirectLink?: string;
}

const Accordion: React.FC<AccordionTypes> = ({ heading, content, colorCode, redirectLink }) => {
	const [isActive, setIsActive] = React.useState(false);

	return (
		<li className="accordion-item">
			<div className={`accordion-toggle ${isActive ? 'active' : ''}`} onClick={() => setIsActive(!isActive)}>
				<h3 className="accordion-heading">{heading}</h3>
				
				<div className="accordion-arrow-wrapper" style={{ backgroundColor: colorCode }}>
					<ArrowDownIcon className="accordion-arrow" />
				</div>
			</div>

			<div className={`accordion-content-wrapper ${isActive ? 'active' : ''}`}>
				<div className="accordion-content" style={{ borderColor: colorCode }}>
					{content}

					<Link className="btn-text accordion-link" to={`/${redirectLink}`}>
						Read more
					</Link>
				</div>
			</div>
		</li>
	);
};

export default Accordion;
